import React, { useState } from 'react';
import { login, register } from '../services/api';

const AuthForm = ({ onLogin }) => {
  const [isLogin, setIsLogin] = useState(true);
  const [formData, setFormData] = useState({
    username: '',
    password: '',
    password_confirm: '',
    email: '',
    signup_key: '',
    first_name: '',
    last_name: '',
  });
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const handleChange = e => {
    const updatedData = {
      ...formData,
      [e.target.name]: e.target.value,
    };

    // For signup, automatically set username to email
    if (!isLogin && e.target.name === 'email') {
      updatedData.username = e.target.value;
    }

    setFormData(updatedData);
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    setErrors({});

    try {
      let userData;
      if (isLogin) {
        userData = await login({
          username: formData.username,
          password: formData.password,
        });
      } else {
        userData = await register({
          email: formData.email,
          password: formData.password,
          password_confirm: formData.password_confirm,
          signup_key: formData.signup_key,
          first_name: formData.first_name,
          last_name: formData.last_name,
        });
      }
      onLogin(userData);
    } catch (error) {
      if (error.response?.data) {
        setErrors(error.response.data);
      } else {
        setErrors({ general: 'An error occurred. Please try again.' });
      }
    } finally {
      setLoading(false);
    }
  };

  const toggleMode = () => {
    setIsLogin(!isLogin);
    setErrors({});
    setFormData({
      username: '',
      password: '',
      password_confirm: '',
      email: '',
      signup_key: '',
      first_name: '',
      last_name: '',
    });
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h2>{isLogin ? 'Sign In' : 'Sign Up'}</h2>

        {errors.general && (
          <div className="error-message">{errors.general}</div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor={isLogin ? 'username' : 'email'}>
              {isLogin ? 'Email/Username:' : 'Email:'}
            </label>
            <input
              type={isLogin ? 'text' : 'email'}
              id={isLogin ? 'username' : 'email'}
              name={isLogin ? 'username' : 'email'}
              value={isLogin ? formData.username : formData.email}
              onChange={handleChange}
              required
            />
            {isLogin && errors.username && (
              <span className="field-error">{errors.username.join(', ')}</span>
            )}
            {!isLogin && errors.email && (
              <span className="field-error">{errors.email.join(', ')}</span>
            )}
          </div>

          {!isLogin && (
            <>
              <div className="form-group">
                <label htmlFor="signup_key">Signup Key:</label>
                <input
                  type="text"
                  id="signup_key"
                  name="signup_key"
                  value={formData.signup_key}
                  onChange={handleChange}
                  required
                  placeholder="Enter your signup key"
                />
                {errors.signup_key && (
                  <span className="field-error">
                    {errors.signup_key.join(', ')}
                  </span>
                )}
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="first_name">First Name:</label>
                  <input
                    type="text"
                    id="first_name"
                    name="first_name"
                    value={formData.first_name}
                    onChange={handleChange}
                  />
                  {errors.first_name && (
                    <span className="field-error">
                      {errors.first_name.join(', ')}
                    </span>
                  )}
                </div>

                <div className="form-group">
                  <label htmlFor="last_name">Last Name:</label>
                  <input
                    type="text"
                    id="last_name"
                    name="last_name"
                    value={formData.last_name}
                    onChange={handleChange}
                  />
                  {errors.last_name && (
                    <span className="field-error">
                      {errors.last_name.join(', ')}
                    </span>
                  )}
                </div>
              </div>
            </>
          )}

          <div className="form-group">
            <label htmlFor="password">Password:</label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
            />
            {errors.password && (
              <span className="field-error">{errors.password.join(', ')}</span>
            )}
          </div>

          {!isLogin && (
            <div className="form-group">
              <label htmlFor="password_confirm">Confirm Password:</label>
              <input
                type="password"
                id="password_confirm"
                name="password_confirm"
                value={formData.password_confirm}
                onChange={handleChange}
                required
              />
              {errors.password_confirm && (
                <span className="field-error">
                  {errors.password_confirm.join(', ')}
                </span>
              )}
              {errors.non_field_errors && (
                <span className="field-error">
                  {errors.non_field_errors.join(', ')}
                </span>
              )}
            </div>
          )}

          <button type="submit" disabled={loading} className="auth-button">
            {loading ? 'Loading...' : isLogin ? 'Sign In' : 'Sign Up'}
          </button>
        </form>

        <p className="auth-toggle">
          {isLogin ? "Don't have an account? " : 'Already have an account? '}
          <button type="button" onClick={toggleMode} className="link-button">
            {isLogin ? 'Sign Up' : 'Sign In'}
          </button>
        </p>
      </div>
    </div>
  );
};

export default AuthForm;
